// separate file so I stop getting nagged in vim about deprecated API.
export const umask = () => process.umask()
